let isDebug = false;

function formatMessage(message) {
	return `Ribbon: ${message}`;
}

function debug(message) {
	if (isDebug) {
		// eslint-disable-next-line no-console
		console.log(formatMessage(message));
	}
}

function error(message) {
	console.error(formatMessage(message));
}

function warn(message) {
	console.warn(formatMessage(message));
}

function enableDebug() {
	isDebug = true;
}

function hit(data) {
	const { DOT } = window;

	if (!DOT) {
		return warn('DOT not found!');
	}

	DOT.hit('event', {
		d: data
	});
}

export { enableDebug, hit, error, warn, debug, formatMessage };
